// Detección de ejecución embebida (iframe de Lexon). Se aísla en un módulo propio para poder
// mockearla en tests: en jsdom `window.top` no es redefinible.
export const isEmbeddedInIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    // Acceso bloqueado por política cross-origin: solo ocurre dentro de un iframe.
    return true;
  }
};
